import { CheckboxesInput } from "./classes/CheckboxesInput";
import { GroupLabel } from "./classes/GroupLabel";
import { LocationInput } from "./classes/LocationInput";
import { PriceInput } from "./classes/PriceInput";
import { Store } from "./classes/Store";
import { SurfaceInput } from "./classes/SurfaceInput";
import { enablePagination } from "./helpers/enablePagination";
import { initDataFromDocument } from "./helpers/initDataFromDocument/initDataFromDocument";
import { getLabelLocalite } from "./helpers/labels/getLabelLocalite";
import { getLabelMore } from "./helpers/labels/getLabelMore";
import { getLabelPrix } from "./helpers/labels/getLabelPrix";
import { getLabelSurface } from "./helpers/labels/getLabelSurface";
import { getLabelTypeDeBien } from "./helpers/labels/getLabelTypeDeBien";
import { getLabelTypeViager } from "./helpers/labels/getLabelTypeViager";
import { saveSearch } from "./helpers/saveSearch";
import { setUrlFromState } from "./helpers/setUrlFromState";
import { startSearch } from "./helpers/startSearch";

/** INIT FUNCTION */

function init() {
  const store = new Store();
  const data = initDataFromDocument();

  // LABELS

  const labelTypeDeBien = new GroupLabel(
    document.getElementById("label-property-type")!,
    getLabelTypeDeBien
  );
  const labelTypeViager = new GroupLabel(
    document.getElementById("label-viager-type")!,
    getLabelTypeViager
  );
  const labelLocalite = new GroupLabel(
    document.getElementById("label-location")!,
    getLabelLocalite
  );
  const labelPrix = new GroupLabel(
    document.getElementById("label-price")!,
    getLabelPrix
  );
  const labelSurface = new GroupLabel(
    document.getElementById("label-surface")!,
    getLabelSurface
  );
  const labelMore = new GroupLabel(
    document.getElementById("label-more")!,
    getLabelMore
  );

  // INPUTS

  new CheckboxesInput({
    store,
    data,
    name: "type-de-bien",
    label: labelTypeDeBien,
  });
  new CheckboxesInput({
    store,
    data,
    name: "type-viager",
    label: labelTypeViager,
  });
  new LocationInput({
    store,
    data,
    label: labelLocalite,
  });
  new PriceInput({
    store,
    data,
    label: labelPrix,
  });
  new SurfaceInput({
    store,
    data,
    label: labelSurface,
  });
  new CheckboxesInput({
    store,
    data,
    name: "nb-piece",
    label: labelMore,
  });
  new CheckboxesInput({
    store,
    data,
    name: "nb-chambre",
    label: labelMore,
  });
  new CheckboxesInput({
    store,
    data,
    name: "annexes",
    label: labelMore,
  });
  new CheckboxesInput({
    store,
    data,
    name: "accessibilite",
    label: labelMore,
  });
  new CheckboxesInput({
    store,
    data,
    name: "type-chauffage",
    label: labelMore,
  });
  new CheckboxesInput({
    store,
    data,
    name: "dpe",
    label: labelMore,
  });

  // SEARCH BUTTONS

  [...document.getElementsByClassName("start-search")].map((button) => {
    button.addEventListener("click", () => startSearch(store));
  });

  // SAVE SEARCH BUTTONS

  [...document.getElementsByClassName("save-search")].map((button) => {
    button.addEventListener("click", () => saveSearch(button));
  });

  // PAGINATION

  enablePagination(store);
}

document.addEventListener("DOMContentLoaded", init);
